export interface CostCentimeterModel {
    id: number,
    reach: number | null,
    centimeterPrice: number | null,
    weigth: number | null,
}

export const costCentimeterModelInitial: CostCentimeterModel = {
    id: 0,
    reach: null,
    centimeterPrice: null,
    weigth: null,
};